import * as tslib_1 from "tslib";
import { Action, Selector, State } from '@ngxs/store';
import { CloseMenu, OpenMenu, OpenNotification, CloseNotification, OpenTimer, CloseTimer, OpenEula, CloseEula } from '../actions/layout.actions';
var LayoutState = /** @class */ (function () {
    function LayoutState() {
    }
    LayoutState.getShowMenu = function (state) {
        return state.showMenu;
    };
    LayoutState.prototype.openMenu = function (_a) {
        var patchState = _a.patchState;
        patchState({
            showMenu: true,
        });
    };
    LayoutState.prototype.closeMenu = function (_a) {
        var patchState = _a.patchState;
        patchState({
            showMenu: false,
        });
    };
    LayoutState.getShowNotification = function (state) {
        return state.showNotification;
    };
    LayoutState.prototype.openNotification = function (_a, data) {
        var patchState = _a.patchState;
        patchState({
            showNotification: tslib_1.__assign({ visible: true }, data)
        });
    };
    LayoutState.prototype.closeNotification = function (_a, data) {
        var patchState = _a.patchState;
        patchState({
            showNotification: tslib_1.__assign({ visible: false }, data)
        });
    };
    LayoutState.getShowTimer = function (state) {
        return state.showTimer;
    };
    LayoutState.prototype.openTimer = function (_a) {
        var patchState = _a.patchState;
        patchState({
            showTimer: true,
        });
    };
    LayoutState.prototype.closeTimer = function (_a) {
        var patchState = _a.patchState;
        patchState({
            showTimer: false,
        });
    };
    LayoutState.getShowEula = function (state) {
        return state.showEula;
    };
    LayoutState.prototype.openEula = function (_a) {
        var patchState = _a.patchState;
        patchState({
            showEula: true,
        });
    };
    LayoutState.prototype.closeEula = function (_a) {
        var patchState = _a.patchState;
        patchState({
            showEula: false,
        });
    };
    tslib_1.__decorate([
        Action(OpenMenu),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState.prototype, "openMenu", null);
    tslib_1.__decorate([
        Action(CloseMenu),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState.prototype, "closeMenu", null);
    tslib_1.__decorate([
        Action(OpenNotification),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState.prototype, "openNotification", null);
    tslib_1.__decorate([
        Action(CloseNotification),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState.prototype, "closeNotification", null);
    tslib_1.__decorate([
        Action(OpenTimer),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState.prototype, "openTimer", null);
    tslib_1.__decorate([
        Action(CloseTimer),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState.prototype, "closeTimer", null);
    tslib_1.__decorate([
        Action(OpenEula),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState.prototype, "openEula", null);
    tslib_1.__decorate([
        Action(CloseEula),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState.prototype, "closeEula", null);
    tslib_1.__decorate([
        Selector(),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState, "getShowMenu", null);
    tslib_1.__decorate([
        Selector(),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState, "getShowNotification", null);
    tslib_1.__decorate([
        Selector(),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState, "getShowTimer", null);
    tslib_1.__decorate([
        Selector(),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], LayoutState, "getShowEula", null);
    LayoutState = tslib_1.__decorate([
        State({
            name: 'layout',
            defaults: {
                showMenu: false,
                showNotification: {
                    state: 'info',
                    message: null,
                    visible: false,
                },
                showTimer: false,
                showEula: false
            },
        })
    ], LayoutState);
    return LayoutState;
}());
export { LayoutState };
